<div class="tCol clickCol" id="MFAEnabled_{{ item.id }}">
    <span *ngIf="item.mfaEnabled">Yes</span>
    <span *ngIf="!item.mfaEnabled">No</span>
</div>
